import { Injectable } from '@angular/core';
import { AuditLog } from '../model/audit-history';
import { ApiService } from './api';

@Injectable()
    
export class AuditService {
    constructor(private api: ApiService) {}

    async getAuditHistory(request: { entityName: string; entityId: string }[]) {
        const url = `${this.api.endpoints.auditHistory}/GetAuditHistory`;
        return this.api.postWithAuth<AuditLog[]>(`${url}`, request);
    }
}



// WEBPACK FOOTER //
// ./src/services/audit.service.ts